export const regionMap = {
	"Region 1": "1 - Los Angeles",
	"Region 2": "2 - San Diego",
	"Region 3": "3 - Bay Area",
	"Region 4": "4 - Northeast",
	"Region 5": "5 - Southeast",
	"Region 6": "6 - Midwest",
	"Region 7": "7 - Texas",
	"Region 8": "8 - Northwest",
	"Costco Business Centers": "9 - Business Centers",
};

export const FILTER_ACTIONS = {
	saveFilter: "Save Filters",
	reset: "Reset to Default",
};

export const FILTER_MSG = {
	save_success: "Filters saved successfully",
	reset_success: "Filters reset to default",
	error: "Could not update filters. Please try again!",
}

export const SAVE_BUTTON_GROUP_OPTIONS = [FILTER_ACTIONS.saveFilter, FILTER_ACTIONS.reset];

export const CRITICALITY_COLOR_MAP = {
	normal: '#339900',
	hotload: '#FFCC00',
	emergency: '#FF0000',
};

export const CRITICALITY_SELECT_OPTIONS = ['Normal', 'Hot Load', 'Emergency'];

export const COL_MAX_MSG = "You can only select up to nine fields. Please adjust your selection.";

export const USER_SHIPMENT_TABLE_COLUMNS = [
    {
        label: "Criticality",
        id: "Criticality",
        isDefault: true,
        isSelected: true,
        sortable: false,
    },
    {
        label: "Delivery Number",
        id: "DeliveryNumber",
        isDefault: true,
        isSelected: true,
        sortable: true,
    },
    {
        label: "PO Number",
        id: "PONumber",
        isDefault: true,
        isSelected: true,
        sortable: true,
    },
    {
        label: "Delivery Appointment",
        id: "DeliveryAppointment",
        isDefault: true,
        isSelected: true,
        sortable: true,
    },
    {
        label: "Delivery Status",
        id: "DeliveryStatus",
        isDefault: true,
        isSelected: true,
        sortable: true,
    },
    {
        label: "NB Number",
        id: "NBNumber",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Source",
        id: "OrgName",
        isDefault: false,
        isSelected: false,
        sortable: false,
    },
    {
        label: "Carrier",
        id: "Carrier",
        isDefault: false,
        isSelected: false,
        sortable: false,
    },
    {
        label: "City",
        id: "City",
        isDefault: false,
        isSelected: false,
        sortable: false,
    },
    {
        label: "Warehouse",
        id: "WareHouseNbr",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Ship Date",
        id: "ShipDate",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Delivery ETA",
        id: "DeliveryEta",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Pick-up Appointment",
        id: "PickupAppointment",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Reschedule Date",
        id: "RescheduleDate",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Customer",
        id: "CustomerName",
        isDefault: false,
        isSelected: false,
        sortable: true,
    },
    {
        label: "Customer Region",
        id: "CustomerRegion",
        isDefault: false,
        isSelected: false,
        sortable: true,
    }
];

export const VALID_NIAGARA_EMAIL_ID = "@niagarawater.com"